/**
 * Inspired from https://github.com/Tonejs/Tone.js/blob/08df7ad68cb9ed4c88d697f2230e3864ca15d206/Tone/source/UserMedia.ts
 */

import assert from "assert";

/**
 * This class aims to open an audio input, requiring user authorization
 */
export class UserMedia extends AudioContext{
  private _mediaStream?: MediaStreamAudioSourceNode;
  private _stream?: MediaStream;
  private _device?: MediaDeviceInfo;

  //   constructor() {
  //     super();
  //   }

  /**
     * Open a MediaStream with default input device
     * @returns UserMedia class
     */
  async open(): Promise<this> {
    // Is UserMedia supported ?
    assert(UserMedia.supported, "UserMedia is not supported");
    // const devices = await UserMedia.enumerateDevices();

    // Set up constraints and audio preprocessing
    const constraints = {
      audio: {
        echoCancellation: false,
        noiseSuppression: true,
        mozNoiseSuppression: true,
        autoGainControl: false,
        sampleRate: this.sampleRate
      }
    };
    
    // Ask for permission with capacitor first
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
        
    // Create the stream is previous one is closed
    this._stream = stream;
    const mediaStreamNode = this.createMediaStreamSource(stream)
    this._mediaStream = mediaStreamNode;

    return this;
  }

  get mediaStream() {
    return this._mediaStream;
  }

  /**
	 * If getUserMedia is supported by the browser.
	 */
  static get supported(): boolean {
    if (typeof navigator.mediaDevices === "undefined" && typeof (navigator.mediaDevices as MediaDevices).getUserMedia === "undefined") {
      return false;
    }
    else {
      return true;
    }
  }

  /**
	 * Returns a promise which resolves with the list of audio input devices available.
	 * @return The promise that is resolved with the devices
	 */
  static async enumerateDevices(): Promise<MediaDeviceInfo[]> {
    const allDevices = await navigator.mediaDevices.enumerateDevices();
    return allDevices.filter(device => {
      return device.kind === "audioinput";
    });
  }
}